import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { CallCodeTypeOptions } from '@apply/constants';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';

/** Id used for the "(None)" row, which clears the call code (the old select's blank option). */
const NO_CALL_CODE = -1;

export const CallCodeField = () => {
    const value = useStandardLoanStore((state) => state.setup.callCodeType);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <DropDownBox
            id='setupCallCodeType'
            value={value ?? null}
            onChange={(callCodeType: number | null) =>
                updateSetup({
                    callCodeType: callCodeType === null || callCodeType === NO_CALL_CODE ? undefined : callCodeType,
                })
            }
            label='Call Code'
            dataSource={[{ id: NO_CALL_CODE, name: '(None)' }, ...CallCodeTypeOptions]}
            displayExpr='name'
            valueExpr='id'
            placeholder='Select'
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
